<h3 class="text-center width-100">
  Embed Web Link
  <i
    class="fa fa-times pull-right close-sidenav"
    aria-hidden="true"
    title="Close Text Block"
    (click)="closeNav()"
  ></i>
</h3>

<div class="container-fluid">
  <div class="edit row w-sm-100 padding-0-25">
    <!-- Dsiclaimer -->
    <div class="col-12 margin-5-0">
      <div class="form-group">
        <label for="name"
          ><strong>Not all external sites allowing linking to a splash page</strong></label
        >
      </div>
    </div>
    <!-- Title and Title color -->
    <div class="col-12 margin-5-0">
      <div class="form-group">
        <label for="name">Title</label>
        <input
          type="text"
          class="form-control"
          id="name"
          aria-describedby="title"
          placeholder="Title"
          [(ngModel)]="title"
        />
      </div>
    </div>
    <div class="col-12 margin-5-0">
      <div class="form-group">
        <label for="targetUrl">Web Link </label>
        <br />
        <input
          type="text"
          class="form-control"
          id="targetUrl"
          aria-describedby="Embed a secured URL"
          placeholder="https://"
          [(ngModel)]="targetUrl"
        />
        <small id="backRepeatHelp" class="form-text text-muted">
          https:// required. If nothing shows up the web link's response header X-Frame-Option is
          probably set to DENY or SAMEORIGIN.
        </small>
      </div>
      <!-- <div class="form-group ">
            <span class="bold inline-block padding-10">{{targetUrl}}</span>
          </div> -->
    </div>
    <div class="col-12 margin-10-0">
      <div class="form-group">
        <label for="height"
          >*Height
          <i
            class="fa question-help fa-question-circle-o"
            aria-hidden="true"
            matTooltip="Requirement for showing the web link into an iframe. Examples: 640px or 80vh"
            [matTooltipPosition]="'after'"
          ></i>
        </label>
        <br />
        <input
          type="text"
          class="form-control"
          id="height"
          aria-describedby="Embed a secured URL"
          placeholder=""
          [(ngModel)]="height"
        />
        <small id="backRepeatHelp" class="form-text text-muted">
          Specify image to constant height. Numbers followed by "px" or "vh" for
          <a href="https://www.w3schools.com/cssref/css_units.asp" target="_blank"> Height</a>
          values.
        </small>
      </div>
    </div>

    <!-- MORE OPTIONS -->
    <div class="edit row">
      <div class="col-12">
        <button
          role="button"
          type="button"
          aria-label="More options"
          class="btn btn-link"
          (click)="isCollapsed = !isCollapsed"
        >
          More Options
          @if (isCollapsed) {
            <i class="fa fa-caret-right" aria-hidden="true"></i>
          }
          @if (!isCollapsed) {
            <i class="fa fa-caret-down" aria-hidden="true"></i>
          }
        </button>
      </div>
    </div>

    <div class="width-100 padding-0-25" [ngbCollapse]="isCollapsed">
      <!--  DESIGN STYLES -->
      <div class="edit row text-center margin-15-0">
        <h3>
          Design Elements
          <i
            class="fa fa-question-circle-o"
            aria-hidden="true"
            style="margin-left: 5px"
            matTooltip="Change the overall font colors, background, and ability to add additional classes"
            [matTooltipPosition]="'right'"
          >
          </i>
        </h3>
      </div>
      <div class="edit row">
        <div class="col-12 margin-5-0">
          <div class="form-group">
            <label for="color">Title Color</label>
            <br />
            <input
              type="text"
              class="form-control color"
              id="color"
              aria-describedby="Font Color"
              placeholder="Enter Font Color"
              [(ngModel)]="color"
            />
            <button
              role="button"
              type="button"
              aria-label="Choose Color"
              class="btn btn-circle"
              [style.background]="color"
              [(colorPicker)]="color"
            ></button>
          </div>
        </div>
        <div class="col-12 margin-5-0">
          <div class="form-group">
            <label for="background">Background Color</label>
            <br />
            <input
              type="text"
              class="form-control color"
              id="background"
              aria-describedby="Background"
              placeholder="Enter Background Color"
              [(ngModel)]="background"
            />
            <button
              role="button"
              type="button"
              aria-label="Choose Color"
              class="btn btn-circle"
              [style.background]="background"
              [(colorPicker)]="background"
            ></button>
          </div>
        </div>
        <!-- <div class="col-12 margin-10-0">
                  <div class="form-group">
                    <label for="className">Additional Classes
                      <i class="fa question-help fa-question-circle-o" aria-hidden="true"
                        matTooltip="Add additional classes through the CSS Editor"
                      [matTooltipPosition]="'after'"></i>
                    </label>
                    <input type="text" class="form-control" id="className"
                      aria-describedby="Additional Class Names defined through the CSS Editor"
                      [(ngModel)]="className"
                      >
                    </div>
                  </div> -->
        <div class="col-12 margin-5-0">
          <div class="form-check">
            <label for="flush" class="form-check-label">
              <input
                style="
                  width: 20px;
                  height: 20px;
                  margin-right: 5px;
                  position: relative;
                  vertical-align: bottom;
                "
                type="checkbox"
                class="form-check-input"
                id="flush"
                [(ngModel)]="flushed"
              />Flush in template.
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="width-100 text-center padding-15 background-color">
      <!-- UPDATE AND SAVE -->
      <div class="padding-10 text-end">
        <button
          role="button"
          type="button"
          aria-label="Preview"
          class="btn btn-link"
          (click)="updateEMBED()"
        >
          Preview
        </button>
        <button
          role="button"
          type="button"
          aria-label="Save and Close"
          class="btn btn-primary"
          (click)="submitEMBED()"
        >
          Save and Close
        </button>
      </div>
    </div>
  </div>
</div>
